import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionClassTypeForm from '../../../components/forms/CompetitionClassTypeForm';
import { useCompetitionClassTypeApi } from '../../../hooks/useCompetitionClassTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionClassTypeDTO } from '../../../services/apiClient';

const CompetitionClassTypeCreate: React.FC = () => {
  const { create, isLoading } = useCompetitionClassTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Class Types', href: '/admin/competitionclasstypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: CompetitionClassTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/competitionclasstypes');
    } catch (error) {
      console.error('Error creating CompetitionClassType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionclasstypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.CompetitionClassType.Edit'
    >
        <CompetitionClassTypeForm
          initialValues={{} as CompetitionClassTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/competitionclasstypes')}
        />
    </AdminLayout>
  );
};

export default CompetitionClassTypeCreate;